<template>
    <CodiceFeanorView tool-module="booleanOps" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
